import '../../../scss/hotfood/components/hotfood-fable.scss'

import { Flex } from '@sainsburys-tech/fable'
import {
  Button,
  ButtonGroup,
  ButtonGroupSection,
  Display2,
  Grid,
  GridItem,
  Modal,
} from '@sainsburys-tech/fable'
import { AlertCircleFilled } from '@sainsburys-tech/icons'

import { AlertMessageKey } from '../../enums/AlertMessageKey'
import { IAlertModalProps } from '../../types/IAlertModalProps'
import {
  CounterTemperatureAlertMessages,
  ICounterTemperatureAlertMessage,
} from '../../utils/TemperatureAlertMessages'

const CounterAlertModal = (props: IAlertModalProps) => {
  const message: ICounterTemperatureAlertMessage =
    CounterTemperatureAlertMessages.get(
      props.alertKey || AlertMessageKey.NoMessageFound,
    ) || {
      instruction: '',
      title: '',
    }

  const getMessageContent = () => (
    <>
      {message && (
        <>
          <Flex alignItems='center' as='h4'>
            <span>
              <AlertCircleFilled className='c-form-alert-icon-red' />
            </span>
            <span data-testid='modalTitle'>
              <Display2>
                {message.title.split('\n').map((line, i) => (
                  <div key={i}>
                    {line}
                    <br />
                  </div>
                ))}
              </Display2>
            </span>
          </Flex>

          <div data-testid='modalDescription'>{message.instruction}</div>
        </>
      )}
    </>
  )

  return (
    <>
      <Modal
        size='sm'
        onClose={() => props.handleClose()}
        isOpen={props.isOpen}
        testid='info-modal'
      >
        {getMessageContent()}

        <ButtonGroup>
          <ButtonGroupSection className='hotfood-full-width'>
            <Grid>
              <GridItem
                className='c-hotfood-modal-button-padding'
                colSpan={{
                  default: 12,
                  xs: 6,
                  sm: 6,
                  md: 6,
                  lg: 6,
                }}
              >
                <Button
                  className='c-hotfood-modal-button c-submit-modal-button hotfood-full-width'
                  onClick={async () => await props.handleAction()}
                  testid='action-button'
                >
                  {message.actionButtonText}
                </Button>
              </GridItem>
            </Grid>
          </ButtonGroupSection>
        </ButtonGroup>
      </Modal>
    </>
  )
}

export default CounterAlertModal
